
import PropTypes from 'prop-types'
import React from 'react'
import ShowHide from '../ShowHide'
import css from './index.module.css'

const Badge = props => {
  const { value, type } = props
  const isHidden = value == null || value === false

  return (
    <ShowHide show={!isHidden}>
      <div className={`${css.badge} ${css[type]}`}>{value}</div>
    </ShowHide>
  )
}

Badge.defaultProps = {
  type: 'default'
}

Badge.propTypes = {
  value: PropTypes.any,
  type: PropTypes.string.isRequired
}

Badge.displayName = 'Badge'

export default Badge



// WEBPACK FOOTER //
// ./ui/Badge/index.js